import { render, staticRenderFns } from "./OpportunityCandidateList.vue?vue&type=template&id=79bb4e1d"
import script from "./OpportunityCandidateList.vue?vue&type=script&lang=js"
export * from "./OpportunityCandidateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports